import { render } from "./SkyPopup.vue?vue&type=template&id=4ed39992"
import script from "./SkyPopup.vue?vue&type=script&lang=js"
export * from "./SkyPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__